import { sva } from '@agapi/ui/panda/css';

export const backInStockDialogStyles = sva({
  slots: ['backdrop', 'dialogContent', 'hiddenTitle', 'hiddenDescription', 'closeButtonContainer', 'formContainer'],
  base: {
    backdrop: {
      position: 'fixed',
      inset: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      backdropFilter: 'blur(3px)',
      zIndex: 1400,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },

    dialogContent: {
      minWidth: 'containers.xs',
      maxWidth: '90vw',
      borderRadius: 'surface.md',
      backgroundColor: 'surface.default.background',
      position: 'relative',
      boxShadow: '1',
      overflow: 'auto',
      maxHeight: '90vh'
    },

    hiddenTitle: {
      position: 'absolute',
      left: '-10000px',
      top: 'auto',
      width: '1px',
      height: '1px',
      overflow: 'hidden'
    },

    hiddenDescription: {
      position: 'absolute',
      left: '-10000px',
      top: 'auto',
      width: '1px',
      height: '1px',
      overflow: 'hidden'
    },

    closeButtonContainer: {
      position: 'absolute',
      top: 5,
      right: 5,
      zIndex: 10
    },

    formContainer: {
      p: 0
    }
  }
});
